import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PostHogService } from '@cropx-common/monitoring/PostHogService';
import { Observable, tap } from 'rxjs';

const SLOW_REQUEST_THRESHOLD = 5000;

@Injectable()
export class RequestTimingInterceptor implements HttpInterceptor {
  private postHogService = inject(PostHogService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const start = performance.now();

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const time = performance.now() - start;
          if (time > SLOW_REQUEST_THRESHOLD) {
            this.postHogService.logUserEventWithDetails('slow_request', {
              url: req.url,
              time: time,
            });
          }
        }
      }),
    );
  }
}
